/** Set true when GET_CONTACT_STATS is available on entitlements */
export const CONTACT_STATS_API_ENABLED = false;

/** Shown on All Contacts overview cards while stats API is disabled */
export const CONTACT_STATS_PLACEHOLDER = {
  totalContacts: "—",
  active30d: "—",
  avgConversion: "—",
  growth: "—",
};

/** Brand primary CTA — mint green (sidebar active / waBtn.primary) */
export const CONTACTS_PRIMARY_BUTTON_CLASS =
  "bg-[hsl(158,48%,36%)] hover:bg-[hsl(158,48%,30%)] text-white font-semibold";

/** Attribute library UI only — no API yet */
export const CAMPAIGN_FILTER_OPTIONS = [
  { value: "diwali", label: "Diwali Festival Sale", campaignId: "c1" },
  { value: "newsletter", label: "Weekly Newsletter", campaignId: "c2" },
  { value: "abandoned", label: "Abandoned Cart", campaignId: "c3" },
];

/** Attribute library UI only — no API yet */
export const ATTRIBUTE_LIBRARY_PLACEHOLDER = [
  {
    id: "attr-1",
    name: "City",
    type: "Text",
    description: "Customer's primary city of residence",
  },
  {
    id: "attr-2",
    name: "Budget",
    type: "Number",
    description: "Estimated budget for purchase",
  },
  {
    id: "attr-3",
    name: "Company Size",
    type: "Dropdown",
    description: "Number of employees (1-50, 50-200, 200+)",
    options: ["1-50", "50-200", "200+"],
  },
  {
    id: "attr-4",
    name: "Renewal Date",
    type: "Date",
    description: "When the current subscription expires",
  },
];

export const DEFAULT_FILTER_ROW = {
  field: "lead_status",
  operator: "is",
  value: "",
  attributeKey: "",
};

export const CONTACTS_PAGE_SIZE = 10;
